export default {"src":"https://cdn.jetlend.ru/_next/static/media/vk.d9be1f49.svg","height":12,"width":20,"blurWidth":0,"blurHeight":0};